import { Outlet } from "react-router-dom"

export function SimpleLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main>
        <Outlet />
      </main>
    </div>
  )
}
